<template>
  <div>
    <NavHeader :activeIndex="'RecommendReports'" />
    <b-card-header class="bg-white">
      <div class="col-12 d-flex justify-content-between align-items-center ">

        <div class="fs-lg-25 fs-sm-10 fs-md-20 font-weight-bolder text-dark">
          <span>重心推荐（3道关卡层层把控）</span>
        </div>
      </div>
      <b-row class="mt-20">
        <b-col md="6" xl="4">
          <b-card img-src="@/assets/images/open/AI2.jpg" img-top img-alt="card img" title="AI大模型预测" class="mb-3">
            <b-card-text>
              第一步：每场比赛都通过自研AI大模型预测平台，进行赛事预测，并且得对应结果。
            </b-card-text>
            <b-card-text>
              <b-avatar size="30" variant="light-danger">
                <feather-icon size="22" icon="ActivityIcon" />
              </b-avatar>
              <span class="fw-bold text-danger text-badge d-inline-block me-10">
                <h6 class="fw-black mb-0">精准预测</h6>
              </span>
            </b-card-text>
          </b-card>
        </b-col>

        <b-col md="6" xl="4">
          <b-card img-src="@/assets/images/open/GL2.jpg" img-top img-alt="card img" title="预设条件过滤" class="mb-3">
            <b-card-text>
              第二步：通过精心预设的条件，系统能够智能过滤掉那些低赔率且胜率不佳的数据，确保每一条推荐都基于深度分析与科学评估。
            </b-card-text>
            <b-card-text>
              <b-avatar size="30" variant="light-info">
                <feather-icon size="22" icon="AlertCircleIcon" />
              </b-avatar>
              <span class="fw-bold text-parmary text-badge d-inline-block me-10">
                <h6 class="fw-black mb-0">智能过滤</h6>
              </span>
            </b-card-text>
          </b-card>
        </b-col>

        <b-col md="6" xl="4">
          <b-card img-src="@/assets/images/open/ZJ2.jpg" img-top img-alt="card img" title="足球专家操盘" class="mb-3">
            <b-card-text>
              第三步：根据前面过滤出来的数据，SoccerPredictor足球专家团队，进一步进行人工分析、筛选，最终得出最优的策略。
            </b-card-text>
            <b-card-text>
              <b-avatar size="30" variant="light-success">
                <feather-icon size="22" icon="AlertCircleIcon" />
              </b-avatar>
              <span class="fw-bold text-success text-badge d-inline-block me-10">
                <h6 class="fw-black mb-0">严格把控</h6>
              </span>
            </b-card-text>
          </b-card>
        </b-col>


      </b-row>
    </b-card-header>

    <div class="card-content mt-20">
      <div class="card mb-25 border-0 rounded-0 bg-white">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13  ">
                    联赛名
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    比赛时间
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    主队
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    比分
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    客队
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    提示时间
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    提示盘口
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    提示比分
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    提示类型
                  </th>

                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                    结果
                  </th>
                </tr>
              </thead>


              <tbody>
                <tr v-for="(item, index) in resultData" :key="item.matchId + index">
                  <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ">
                    <div class="d-flex align-items-center">

                      <img v-if="item.gameImg != null" :src="`http://lcsjfx.com/football/${item.gameImg}`"
                        class="rounded-circle " width="20" height="20" alt="user" />
                      <span class="d-block text-primary">{{ item.gameName }} </span>
                    </div>
                  </th>
                  <td>
                    {{ item.matchTimeStr }}

                  </td>
                  <td class="shadow-none lh-1">
                    <div class="d-flex align-items-center">
                      <img v-if="item.homeImg != null" :src="`http://lcsjfx.com/football/${item.homeImg}`" width="20"
                        height="20" class="rounded-1 me-10" alt="project-image" />

                      <span class="d-block me-10">{{ item.teams1 }}</span>
                    </div>
                  </td>
                  <td class="shadow-none lh-1">
                    <div class="d-flex align-items-center">

                      <span class="fw-bold text-success text-badge d-inline-block me-10">
                        <h6 class="fw-black mb-0">{{ item.lastScore.split('-')[0] }}</h6>
                      </span>
                      ：
                      <span class="fw-bold text-danger text-badge d-inline-block me-10">
                        <h6 class="fw-black mb-0">{{ item.lastScore.split('-')[1] }}</h6>
                      </span>

                    </div>
                  </td>
                  <td class="shadow-none lh-1">
                    <div class="d-flex align-items-center">

                      <img v-if="item.guestImg != null" :src="`http://lcsjfx.com/football/${item.guestImg}`" width="20"
                        height="20" class="rounded-1 me-10" alt="project-image" />
                      <span class="d-block me-10">{{ item.teams2 }}</span>
                    </div>
                  </td>
                  <td class="shadow-none lh-1 fw-bold text-body-tertiary text-warning">
                    {{ item.status }} ′
                  </td>
                  <td class="shadow-none lh-1 fw-bold text-body-tertiary ">
                    <span class="text-danger">{{ item.handicap }}</span>
                  </td>
                  <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                    <span class="text-primary">{{ item.score }}</span>
                  </td>
                  <td class="shadow-none lh-1 fw-medium">
                    <span class="badge bg-primary fs-10"
                      v-if="item.betTypeStr.includes('大') || item.betTypeStr.includes('主') || item.betTypeStr == '胜'">{{
                        item.betTypeStr }}</span>
                    <span class="badge bg-info fs-10"
                      v-if="item.betTypeStr.includes('小') || item.betTypeStr.includes('客') || item.betTypeStr.includes('负')">{{
                        item.betTypeStr }}</span>
                    <span class="badge bg-dark fs-10" v-if="item.betTypeStr.includes('平')">{{ item.betTypeStr }}</span>
                  </td>
                  <!-- style="background-color: red;" -->
                  <td class="shadow-none lh-1 fw-medium text-body-tertiary ">
                    <span class="text-danger fs-15 fw-bold "
                      v-if="item.jsStatusStr === '赢' || item.jsStatusStr === '赢半'">
                      <!-- <feather-icon icon="CheckIcon" size="30" /> -->
                      <span>正确</span>
                    </span>
                    <span class="text-dark" v-else-if="item.jsStatusStr === '走水'">{{ item.jsStatusStr }}</span>
                    <span class="text-dark" v-else></span>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request.js';
import NavHeader from './NavHeader.vue'

export default {
  components: {
    NavHeader,
  },
  data() {
    return {
      resultData: [],
    };
  },
  created() {
    this.showHisDetail();
  },
  mounted() {
    // this.showHisDetail();
  },
  methods: {
    async showHisDetail() {
      let post_url = 'football/admin/william/interfaceAction!getDetailByKeynote.action';
      post_url = post_url + '?keynote=2';
      let opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      await request.openHttpRequest(opts).then(response => {
        if (response == null) {
          // this.$message.error('网络连接异常');
          return;
        }
        if (response.data.status == 0) {
          return;
        }
        this.resultData = response.data.Statistics;
      });
    },


  }
}
</script>
